import * as ReactQuery from 'react-query';
import { PatientFileDto } from 'common/api';
import { InferQueryOptions } from 'services';
import { downloadFile } from 'utils/document';

import {
  getPatientFileDownloadUrlAPI,
  getPatientFilesAPI,
  getPatientFilesArchiveAPI,
} from './api';

export const GET_PATIENT_FILES_KEY = '@patient-files/list';

export function useGetPatientFiles(
  referralId = '',
  options?: InferQueryOptions<typeof getPatientFilesAPI>
) {
  const { data, isLoading, isError, refetch } = ReactQuery.useQuery(
    [GET_PATIENT_FILES_KEY, referralId],
    () => getPatientFilesAPI(referralId),
    {
      ...options,
      enabled: Boolean(referralId) && (options?.enabled ?? true),
    }
  );

  return {
    files: data,
    isLoading,
    isError,
    refetch,
  };
}

export async function downloadPatientFile(
  referralId: string,
  file: PatientFileDto
) {
  const { url } = await getPatientFileDownloadUrlAPI(referralId, file.id);
  downloadFile(url, file.fileName);
}

export async function downloadPatientFilesArchive(
  referralId: string,
  patientInternalId: number | string
) {
  const archive = await getPatientFilesArchiveAPI(referralId);
  const blobUrl = URL.createObjectURL(archive);
  downloadFile(blobUrl, `${patientInternalId} - medical records.zip`);
  window.setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
}
